<template>
  <v-list class="dropdown-list">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>
          No new notifications.
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'NoNotifications'
}
</script>

<style scoped>

</style>
